<app-nav></app-nav>

<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<main class="page" *ngIf="!isLoading">

  <section class="head">
    <div class="head-bg" style="background-image: url('assets/contacts/hero-bg.jpg')"></div>

    <div class="head-text">
      <h1>My <span>Contacts</span></h1>
      <p>Manage your contacts, build relationships and grow your network.</p>
    </div>

    <div class="head-script">People<br />Connections<br />Opportunities</div>
    <div class="head-quote">One Network<br /><span>Endless<br />Opportunities.</span></div>
  </section>

  <section class="stats">
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-users"></i></div>
      <div><span>All Contacts</span><b>{{ all.length }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-user-check"></i></div>
      <div><span>Members</span><b>{{ count('member') }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-address-book"></i></div>
      <div><span>My Contacts</span><b>{{ count('custom') }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-star"></i></div>
      <div><span>Favorites</span><b>{{ count('fav') }}</b></div>
    </div>
  </section>

  <section class="layout">

    <!-- LIST -->
    <div class="list-card">
      <div class="tabs">
        <button type="button" *ngFor="let t of tabs" [class.active]="tab === t.key" (click)="tab = t.key">
          {{ t.label }} ({{ count(t.key) }})
        </button>
      </div>

      <div class="toolbar">
        <div class="t-search">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input type="search" placeholder="Search your contacts..." [(ngModel)]="searchText"
                 [ngModelOptions]="{standalone: true}" autocomplete="off" />
        </div>
        <div class="t-sort">
          <i class="fa-solid fa-arrow-down-wide-short"></i>
          <select [(ngModel)]="sortBy" [ngModelOptions]="{standalone: true}">
            <option value="newest">Newest First</option>
            <option value="name">Name A-Z</option>
          </select>
        </div>
        <button type="button" class="btn-pink" (click)="addContact()">
          <i class="fa-solid fa-user-plus"></i> Add Contact
        </button>
      </div>

      <ul class="rows">
        <li *ngFor="let c of filtered" [class.sel]="selected?.key === c.key" (click)="select(c)">
          <img [src]="c.photo || 'assets/images/avatar.png'"
               (error)="$any($event.target).src='assets/images/avatar.png'" class="av" alt="" />

          <div class="who">
            <b>{{ c.name }} <i class="fa-solid fa-star fav" *ngIf="isFav(c)"></i></b>
            <small>{{ c.sub }}</small>
          </div>

          <div class="meta">
            <span class="badge" [ngClass]="badgeClass(c)">{{ badgeText(c) }}</span>
            <small>{{ c.type === 'member' ? presence.statusText(c.raw.user) : c.location }}</small>
          </div>

          <div class="acts">
            <button type="button" *ngIf="c.type === 'member' && c.status === 'Accepted'" (click)="message(c, $event)" title="Message">
              <i class="fa-solid fa-comment-dots"></i>
            </button>
            <button type="button" *ngIf="c.email" (click)="mail(c, $event)" title="Email">
              <i class="fa-solid fa-envelope"></i>
            </button>
            <button type="button" *ngIf="canCall(c)" (click)="call(c, $event)" title="Call">
              <i class="fa-solid fa-phone"></i>
            </button>
            <button type="button" class="more" (click)="toggleMenu(c.key, $event)">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>

            <ul class="pop" *ngIf="menuKey === c.key">
              <li (click)="toggleFav(c, $event)">
                <i class="fa-star" [ngClass]="isFav(c) ? 'fa-solid' : 'fa-regular'"></i>
                {{ isFav(c) ? 'Remove Favorite' : 'Add Favorite' }}
              </li>
              <li *ngIf="c.type === 'custom'" (click)="editContact(c.raw)"><i class="fa-regular fa-pen-to-square"></i> Edit</li>
              <li *ngIf="c.type === 'custom'" class="danger" (click)="deleteContact(c.raw)"><i class="fa-solid fa-trash"></i> Delete</li>
            </ul>
          </div>
        </li>
      </ul>

      <p class="empty" *ngIf="filtered.length === 0">No contacts found.</p>
    </div>

    <!-- DETAIL -->
    <aside class="detail" *ngIf="selected as s">
      <div class="d-top">
        <img [src]="s.photo || 'assets/images/avatar.png'"
             (error)="$any($event.target).src='assets/images/avatar.png'" class="d-av" alt="" />
        <div class="d-id">
          <h3>{{ s.name }}</h3>
          <span class="badge" [ngClass]="badgeClass(s)">{{ badgeText(s) }}</span>
        </div>
        <button type="button" class="star" (click)="toggleFav(s)">
          <i class="fa-star" [ngClass]="isFav(s) ? 'fa-solid on' : 'fa-regular'"></i>
        </button>
      </div>

      <p class="d-sub" *ngIf="s.sub">{{ s.sub }}</p>
      <p class="d-loc" *ngIf="s.location"><i class="fa-solid fa-location-dot"></i> {{ s.location }}</p>

      <div class="d-btns">
        <button type="button" class="b-pink" *ngIf="s.type === 'member' && s.status === 'Accepted'" (click)="message(s)">
          <i class="fa-solid fa-comment-dots"></i> Send Message
        </button>
        <button type="button" class="b-out" *ngIf="s.email" (click)="mail(s)">
          <i class="fa-solid fa-envelope"></i> Send Email
        </button>
        <button type="button" class="b-out" *ngIf="canCall(s)" (click)="call(s)">
          <i class="fa-solid fa-phone"></i> Call
        </button>
        <button type="button" class="b-out" (click)="share(s)">
          <i class="fa-solid fa-share-nodes"></i> Share Contact
        </button>
      </div>

      <h4 *ngIf="s.phone || s.email">Details</h4>
      <p class="d-line" *ngIf="s.phone"><i class="fa-solid fa-phone"></i> {{ s.phone }}</p>
      <p class="d-line" *ngIf="s.email"><i class="fa-solid fa-envelope"></i> {{ s.email }}</p>

      <ng-container *ngIf="socials(s) as soc">
        <h4 *ngIf="soc.length">Social Links</h4>
        <div class="socials">
          <a *ngFor="let x of soc" [href]="x.url" target="_blank" rel="noopener"><i [class]="x.icon"></i></a>
        </div>
      </ng-container>

      <h4 *ngIf="s.tags.length">Tags</h4>
      <div class="tags" *ngIf="s.tags.length"><span *ngFor="let t of s.tags">{{ t }}</span></div>

      <h4>Notes</h4>
      <textarea rows="3" placeholder="Add a note about this contact..."
                [ngModel]="notes[s.key]" (ngModelChange)="setNote(s.key, $event)"
                [ngModelOptions]="{standalone: true}"></textarea>
    </aside>
  </section>
</main>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showModal, 'd-block': showModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" style="height: 500px; overflow-y: auto">
      <div class="modal-header">
        <h5 class="modal-title">Add Contact</h5>
        <button type="button" class="close" (click)="closeAddContactModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="contactForm">
          <div class="row">
            <div class="form-group col-md-6">
              <label style="margin-top: 5px; margin-bottom: 5px" for="firstName"
                >First Name</label
              >
              <input
                type="text"
                class="form-control"
                id="firstName"
                formControlName="firstName"
              />
            </div>
            <div class="form-group col-md-6">
              <label style="margin-top: 5px; margin-bottom: 5px" for="lastName"
                >Last Name</label
              >
              <input
                type="text"
                class="form-control"
                id="lastName"
                formControlName="lastName"
              />
            </div>
          </div>

          <div class="form-group">
            <label for="tags">Tags</label>
            <input
              type="text"
              class="form-control"
              id="tags"
              formControlName="tags"
            />
          </div>

          <div class="form-group">
            <label style="margin-top: 5px; margin-bottom: 5px"
              >Phone Number</label
            >
            <div formArrayName="phoneNumbers">
              <div
                *ngFor="let phone of phoneNumbers.controls; let i = index"
                class="input-group"
                style="margin-bottom: 10px"
              >
                <input
                  type="text"
                  class="form-control"
                  [formControlName]="i"
                  placeholder="Enter Phone Number"
                />
                <div class="input-group-append">
                  <button
                    *ngIf="i > 0"
                    class="btn btn-primary plus-button"
                    type="button"
                    (click)="removePhoneNumber(i)"
                  >
                    −
                  </button>
                  <button
                    *ngIf="i == 0"
                    class="btn btn-primary plus-button"
                    type="button"
                    (click)="addPhoneNumber()"
                  >
                    <span class="">+</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label style="margin-top: 5px; margin-bottom: 5px">Email</label>
            <div formArrayName="emails">
              <div
                *ngFor="let email of emails.controls; let i = index"
                class="input-group"
                style="margin-bottom: 10px"
              >
                <input
                  type="text"
                  class="form-control"
                  [formControlName]="i"
                  placeholder="Enter Email"
                />
                <div class="input-group-append">
                  <button
                    *ngIf="i > 0"
                    class="btn btn-primary plus-button"
                    type="button"
                    (click)="removeEmail(i)"
                  >
                    −
                  </button>
                  <button
                    *ngIf="i == 0"
                    class="btn btn-primary plus-button"
                    type="button"
                    (click)="addEmail()"
                  >
                    <span class="">+</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label style="margin-top: 5px; margin-bottom: 5px">Address</label>
            <div formArrayName="addresses">
              <div
                *ngFor="let address of addresses.controls; let i = index"
                class="input-group"
                style="margin-bottom: 10px"
              >
                <input
                  type="text"
                  class="form-control"
                  [formControlName]="i"
                  placeholder="Enter Address"
                />
                <div class="input-group-append">
                  <button
                    *ngIf="i > 0"
                    class="btn btn-primary plus-button"
                    type="button"
                    (click)="removeAddress(i)"
                  >
                    −
                  </button>
                  <button
                    *ngIf="i == 0"
                    class="btn btn-primary plus-button"
                    type="button"
                    (click)="addAddress()"
                  >
                    <span class="">+</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div>
              <label class="form-check-label">
                <input type="radio" formControlName="gender" value="male" />
                Male
              </label>
              <label class="form-check-label" style="margin-left: 10px">
                <input type="radio" formControlName="gender" value="female" />
                Female
              </label>
            </div>
          </div>
          <div class="form-group">
            <label style="margin-top: 5px; margin-bottom: 5px" for="company"
              >Company</label
            >
            <input
              type="text"
              class="form-control"
              id="company"
              formControlName="company"
              placeholder="Enter Company"
            />
          </div>
          <div class="form-group">
            <label style="margin-top: 5px; margin-bottom: 5px" for="position"
              >Position</label
            >
            <input
              type="text"
              class="form-control"
              id="position"
              formControlName="position"
              placeholder="Enter Positon"
            />
          </div>

          <div class="form-group">
            <label style="margin-top: 5px; margin-bottom: 5px">Website</label>
            <div formArrayName="websites">
              <div
                *ngFor="let website of websites.controls; let i = index"
                class="input-group"
                style="margin-bottom: 10px"
              >
                <input
                  type="text"
                  class="form-control"
                  [formControlName]="i"
                  placeholder="Enter Website"
                />
                <div class="input-group-append">
                  <button
                    *ngIf="i > 0"
                    class="btn btn-primary plus-button"
                    type="button"
                    (click)="removeWebsite(i)"
                  >
                    −
                  </button>
                  <button
                    *ngIf="i == 0"
                    class="btn btn-primary plus-button"
                    type="button"
                    (click)="addWebsite()"
                  >
                    <span class="">+</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label style="margin-top: 5px; margin-bottom: 5px" for="facebook"
              >Facebook</label
            >
            <input
              type="text"
              class="form-control"
              id="facebook"
              formControlName="facebook"
              placeholder="Enter Facebook ID"
            />
          </div>
          <div class="form-group">
            <label style="margin-top: 5px; margin-bottom: 5px" for="twitter"
              >Twitter</label
            >
            <input
              type="text"
              class="form-control"
              id="twitter"
              formControlName="twitter"
              placeholder="Enter Twitter ID"
            />
          </div>
          <div class="form-group">
            <label style="margin-top: 5px; margin-bottom: 5px" for="linkedin"
              >Linkedin</label
            >
            <input
              type="text"
              class="form-control"
              id="linkedin"
              formControlName="linkedin"
              placeholder="Enter Linkedin ID"
            />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeAddContactModal()"
        >
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="saveContact()">
          Add Contact
        </button>
      </div>
    </div>
  </div>
</div>
